<template>
<div class="operational-log-wrapper">
  <TopSearchListBar>
    <!--左侧按钮支持多个solt-->
    <!--右侧select支持多个solt-->
    <el-date-picker
      class="oper-data"
      slot="right"
      v-model="search.time"
      type="datetimerange"
      range-separator="-"
      :start-placeholder="startTimeHolder"
      :end-placeholder="endTimeHolder"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      @change="searchChange"
    />
    <el-select
      slot="right"
      v-model="search.type"
      :placeholder="typePlaceholder"
      clearable
      @change="searchChange"
    >
      <el-option
        v-for="(item,index) in typeList"
        :key="index"
        :label="item.show"
        :value="item.value"
      />
    </el-select>
    <el-select
     class="selectSecond"
      slot="right"
      v-model="search.name"
      :placeholder="operatorHolder"
      clearable
      @change="searchChange"
    >
      <el-option
        v-for="(item,index) in nameList"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>
    <Search
      slot="right"
      :has-input="true"
      :placeholder="keyWordsHolder"
      @searchChange="keywordChange"
      @inputChange="keywordChange"
    >
      <Select
        slot="right"
        :init-value="keywordSearch.keywordType"
        :options="questionOptions"
        :top-or-bottom="40"
        @menuClick="questionTypeChange"
      />
    </Search>
  </TopSearchListBar>
  <el-table
    :data="listInfo.list"
    width="100%"
  >
    <el-table-column
      prop="user"
      :label="operatorName"
    />
    <el-table-column
      prop="operation_type"
      :label="operationType"
    />
    <el-table-column
      prop="create_time"
      :label="operationTime"
    />
    <el-table-column
      prop="question"
      :label="StandardQuestion"
    />
    <el-table-column
     :label="operateContent"
    >
      <template slot-scope="scope">
        <OptContentColumn :row="scope.row" />
      </template>
    </el-table-column>
  </el-table>
  <!--分页，修改pageSize-->
  <FooterPage
    :size="listInfo.size"
    :total="listInfo.total"
    :page="listInfo.page"
    @sizeChange="sizeChange"
    @pageChange="pageChange"
  >
    <!--各种按钮solt-->
  </FooterPage>
</div>
</template>

<script>
import Vue from 'vue';
import dateFormat from 'dateformat';
import OptContentColumn from './OptContentColumn';
import { getTypeListApi,getRecordListApi, getOperatorListApi } from '@/views/zhiji/js/services/service'
import TopSearchListBar from '@/views/zhiji/components/top-searchlist-bar.vue';
import FooterPage from '@/views/zhiji/components/foot-page.vue';
import Search from '@/views/zhiji/bComponents/inputs/Search';
import Select from '@/views/zhiji/bComponents/inputs/Select';
import { debounce } from '@/views/zhiji/js/common/util';

export default {
  name: 'OperationalLog',
  components: {
    OptContentColumn,
    Search,
    Select,
    TopSearchListBar,
    FooterPage
  },
  data () {
    return {
      search: {
        time: ['', ''],
        name: '',
        type: '',
      },
      keywordSearch: {
        keywordType: 'question',
        keyword: '',
      },
      listInfo: {
        list: [],
        page: 1,
        size: 10,
        total: 1,
        status: 'start', // 'start' //初始状态 'loading' 加载中,'loadingend' 加载完成
      },
      nameList: [],
      typeList: [],
    };
  },
      computed: {
        startTimeHolder() {
            return this.$t("zhiji.personnel.ulogManage.startTimeTip")
        },
        endTimeHolder() {
            return this.$t("zhiji.personnel.ulogManage.endTimeTip");
        },
        typePlaceholder() {
            return this.$t("zhiji.personnel.ulogManage.typePlaceholder");
        },
        operatorHolder() {
            return this.$t("zhiji.personnel.ulogManage.operatorHolder");
        },
        keyWordsHolder() {
            return this.$t("zhiji.personnel.ulogManage.keyWordsHolder");
        },
        operatorName() {
            return this.$t("zhiji.personnel.ulogManage.tableCloumn.operator");
        },
        operationType() {
            return this.$t("zhiji.personnel.ulogManage.tableCloumn.operationType");
        },
        operationTime() {
            return this.$t("zhiji.personnel.ulogManage.tableCloumn.operationTime");
        },
        StandardQuestion() {
            return this.$t("zhiji.personnel.ulogManage.tableCloumn.StandardQuestion");
        },
        operateContent() {
            return this.$t("zhiji.personnel.ulogManage.tableCloumn.operateContent");
        },
        questionOptions() {
            return  [{
        label: this.$t("zhiji.knowlege.byStandard"),
        value: 'question',
      },
      {
        label: this.$t("zhiji.knowlege.bySimilar"),
        value: 'ext_question',
      },
      {
        label: this.$t("zhiji.knowlege.byAnswer"),
        value: 'answer',
      },
      {
        label: this.$t("zhiji.knowlege.byStandId"),
        value: 'question_id',
      }]
     }
    },
      watch: {
      async startTimeHolder() {
         this.getList();
         let newType = await getTypeListApi( {startTime:this.search.time[0], endTime:this.search.time[1] });
         this.typeList = newType
        }
    },
  async mounted () {
    const date = new Date(); // 今天
    const date2 = new Date().setDate(date.getDate() - 7); // 七天前
    const startTime = dateFormat(date2, 'yyyy-mm-dd HH:MM:ss');
    const endTime = dateFormat(date, 'yyyy-mm-dd HH:MM:ss');
    // elment-ui 和此控件M处理不同
    this.search.time = [startTime, endTime];
    this.nameList = await getOperatorListApi({ startTime, endTime });
    this.typeList = await getTypeListApi({ startTime, endTime }); //这里
    this.getList();
    this.searchHandler = debounce((data) => {
      this.keywordSearch.keyword = data[0].value;
      this.getList();
    }, 500);
  },
  methods: {
    async searchChange () {
      const startTime = this.search.time[0];
      const endTime = this.search.time[1];
      this.typeList = await getTypeListApi({ startTime, endTime });
      this.listInfo.page = 1;
      this.getList();
    },
    async getList () {
      // TODO 列表类页面通用逻辑
      const { page, size, status } = this.listInfo;
      const {
        name,
        type,
        time: [startime, endtime],
      } = this.search;
      let { keywordType, keyword } = this.keywordSearch;
      if (!keyword) {
        keywordType = '';
      }
      if (status == 'loading') {
        return;
      }
      const { list, total } = await getRecordListApi({
        startime,
        endtime,
        page,
        size,
        type,
        name,
        keywordType,
        keyword,
      });
      this.listInfo.list = list;
      this.listInfo.total = total;
      this.listInfo.status = 'loadingend';
    },
    sizeChange (newSize) {
      this.listInfo.size = newSize;
      this.listInfo.page = 1;
      this.getList();
    },
    pageChange (newPage) {
      this.listInfo.page = newPage;
      this.getList();
    },
    keywordChange (data) {
      // 搜索关键字
      this.searchHandler(data);
    },
    questionTypeChange (data) {
      // 搜索关键字类型
      this.keywordSearch.keywordType = data.value;
    },
  },
};
</script>

<style lang="less" scoped>
.operational-log-wrapper {
    background: #fff;
    padding: 0 24px 24px 24px;
    border: 1px solid #D9E4EF;
    margin: 16px 16px 16px 16px;
    border-radius: 4px;

    /deep/.foot-wrapper .list-footer-page{
        text-align: center;
        border: 1px solid #fff;
        margin: -1px -1px -1px -1px;
        padding-top: 20px;
        .el-pagination__editor.el-input .el-input__inner {
            border: 1px solid #aec5d8;
            &:hover {
                border-color: #2088f3;
            }
        }
  }
}
.oper-data{
    margin-right: 16px;
    vertical-align: top;
}
.selectSecond{
    margin: 0px 10px;
}
/deep/.el-icon-circle-close:before {
    color: #838896;
}
</style>
